import React from "react";
import MarketingNav from "../../components/MarketingNav";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import { BookOpen } from "lucide-react";

const sections = [
  { title: "Getting Started", items: ["Install the Gateway", "Point your SDK", "Your first policy", "Query decisions"] },
  { title: "SentryDSL", items: ["Match rules", "Actions (allow/deny/redact/flag)", "Reasons and metadata", "Bundle compilation"] },
  { title: "Deployment", items: ["Multi-tenant SaaS", "Single-tenant VPC", "Customer-VPC / on-prem", "AWS Nitro Enclave"] },
  { title: "Compliance", items: ["EU AI Act Article 14", "NIST AI RMF mapping", "SOC 2 controls", "HIPAA BAA", "FedRAMP roadmap"] },
  { title: "APIs", items: ["/v1/policies", "/v1/gateway/evaluate", "/v1/decisions", "/v1/evidence/:id", "/v1/audit-bundles"] },
  { title: "Observatory", items: ["Ingestion SDK", "GraphQL query API", "Causal Trace Graph", "Drift detection", "Exports (Snowflake, Databricks)"] },
];

export default function Docs() {
  return (
    <div>
      <SEO
        path="/docs"
        title="Documentation · SentryDSL, SDKs & APIs"
        description="Install the Sentry Gateway, author your first SentryDSL policy, and query decisions. Full reference for /v1/policies, /v1/gateway/evaluate, /v1/decisions, /v1/evidence, and the Observatory ingestion API."
        keywords="Sentry docs, SentryDSL, LLM policy language, AI gateway API, LLM evidence API, Observatory SDK"
      />
      <MarketingNav />
      <section className="container-x py-16">
        <div className="max-w-2xl">
          <span className="chip chip-orange mb-6"><BookOpen size={12}/> Documentation</span>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-navy">Everything you need to ship in a day.</h1>
          <p className="ink mt-4 text-lg">Sentry is designed to be a drop-in replacement for your provider endpoint. Point your SDK. Author your policies. Ship.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {sections.map(s => (
            <div key={s.title} className="rounded-2xl bg-white border border-[rgba(17,30,51,0.08)] p-6">
              <div className="font-display font-bold text-navy mb-3">{s.title}</div>
              <ul className="space-y-2 text-sm">
                {s.items.map(i => <li key={i}><a href="#" className="ink hover:text-[#FF6B35]">{i}</a></li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
